import { authenticate } from '@cian/auth';
import { ValidationError } from '@cian/peperrors/shared';

import { Dispatch } from 'react';

import {
  EFrequency,
  ESource,
} from 'shared/repositories/saved-searches/entities/create_saved_search/CreateSavedSearchWebPublicRequestSchema';
import { EStatus } from 'shared/repositories/saved-searches/entities/create_saved_search/CreateSavedSearchWebPublicResponseSchema';
import {
  TWebCreateSavedSearchResponse,
  fetchWebCreateSavedSearch,
} from 'shared/repositories/saved-searches/v1/web/create-saved-search';
import { getErrorMessage } from 'shared/utils/getErrorMessage';

import { IJsonQuery } from '../../../json_query';
import { IApplicationContext } from '../../../types/applicationContext';
import { actionGenerator } from '../../../utils/redux';

import { EAction, IState, TActions } from './types';

export const setEmail = actionGenerator<EAction.SetEmail, string>(EAction.SetEmail);
export const setSubscribeToNews = actionGenerator<EAction.SetSubscribeToNews, boolean>(EAction.SetSubscribeToNews);
export const setStatusLoading = actionGenerator<EAction.SetStatusLoading>(EAction.SetStatusLoading);
export const setStatusSucceed = actionGenerator<EAction.SetStatusSucceed, boolean>(EAction.SetStatusSucceed);
export const setStatusFailed = actionGenerator<EAction.SetStatusFailed, string[]>(EAction.SetStatusFailed);

interface ISubscribeParameters {
  context: IApplicationContext;
  title: string;
  jsonQuery: IJsonQuery;
  state: IState;
  dispatch: Dispatch<TActions>;
}

export async function subscribe({
  context: { httpApi, logger, microfrontendsAPI },
  title,
  jsonQuery,
  state,
  dispatch,
}: ISubscribeParameters): Promise<void> {
  dispatch(setStatusLoading());

  try {
    const saveSearchResponse: TWebCreateSavedSearchResponse = await fetchWebCreateSavedSearch({
      httpApi,
      parameters: {
        jsonQuery,
        source: ESource.Listing,
        subscribeNews: state.subscribeToNews,
        email: state.email,
        frequency: EFrequency.Daily,
        title,
      },
    });

    if (saveSearchResponse.statusCode !== 200) {
      dispatch(
        setStatusFailed(
          ((saveSearchResponse.response.errors || []) as { message: string }[]).map(error => error.message),
        ),
      );

      throw new ValidationError({
        message: getErrorMessage(saveSearchResponse.response.message),
        domain: 'src/shared/containers/PreInfiniteSaveSearchContainer/state/actions.ts',
      });
    }

    const {
      response: { status, logonInfo },
    } = saveSearchResponse;

    if (logonInfo) {
      try {
        await authenticate(logonInfo.logOnInfo, logonInfo.login, true);

        void microfrontendsAPI?.header.updateHeader();
      } catch (ex) {
        logger.error(ex);
      }
    }

    dispatch(setStatusSucceed(status === EStatus.EmailConfirmationRequired));
  } catch (ex) {
    if (ValidationError.is(ex)) {
      throw ex;
    }

    logger.error(ex);

    dispatch(setStatusFailed(['Извините, произошла неизвестная ошибка. Попробуйте ещё раз']));

    throw ex;
  }
}
